<template>
	<cm-lightbox v-if="lightboxObjectEditVisible" @lgbcancel="onCancel">
		<template v-slot:header>{{ lightbox?.header }}</template>

		<template v-slot:body>
			<div class="lightbox__block" v-for="(block, index) in lightbox.body" :key="index">
				<template v-if="block.kind === 'single'">
					<div class="lightbox__title">{{ block.title }}</div>
					<cm-dropdown
						:type="block.dropdown.type"
						:name="block.name"
						:items="block.dropdown.categories"
						:value="block.dropdown.value"
						:status="block.dropdown.status"
						:disabled="block.disabled"
						:system="block.dropdown.system"
						v-if="block.dropdown"
						@click="onChange($event, 'dropdown')"
					/>
					<cm-input
						:type="'text'"
						:name="block.name"
						:value="block.value"
						:status="block.status"
						:disabled="block.disabled"
						v-else
						@input="onChange($event, 'input')"
						@paste="onChange($event, 'input')"
						@change="onChange($event, 'input')"
						@blur="onChange($event, 'input')"
					/>
				</template>
				<template v-if="block.kind === 'double'">
					<div class="lightbox__subblock" data-part="first">
						<div class="lightbox__title">{{ block.first.title }}</div>
						<cm-input
							:type="'text'"
							:name="block.first.name"
							:value="block.first.value"
							:status="block.first.status"
							:disabled="block.first.disabled"
							@input="onChange($event, 'input')"
							@paste="onChange($event, 'input')"
							@change="onChange($event, 'input')"
							@blur="onChange($event, 'input')"
						/>
					</div>
					<div class="lightbox__subblock" data-part="last">
						<div class="lightbox__title">{{ block.last.title }}</div>
						<cm-input
							:type="'text'"
							:name="block.last.name"
							:value="block.last.value"
							:status="block.last.status"
							:disabled="block.last.disabled"
							@input="onChange($event, 'input')"
							@paste="onChange($event, 'input')"
							@change="onChange($event, 'input')"
							@blur="onChange($event, 'input')"
						/>
					</div>
				</template>
			</div>

			<div class="lightbox__preloader" v-if="loading">Loading ...</div>
		</template>
		<template v-slot:footer>
			<cm-button type="text" value="Сохранить объект" paint="blue" :disabled="!validation" @click="onApply" />
		</template>
	</cm-lightbox>
</template>

<script>
	import axios from "axios";
	import { mapGetters, mapMutations, mapActions } from "vuex";

	import Lightbox from "../appearance/Lightbox.vue";
	import Button from "../components/Button.vue";
	import Dropdown from "../components/Dropdown.vue";
	import Input from "../components/Input.vue";

	export default {
		components: {
			"cm-button": Button,
			"cm-dropdown": Dropdown,
			"cm-input": Input,
			"cm-lightbox": Lightbox,
		},
		data() {
			return {
				loading: false,
				lightbox: null,
				type: null,
				regions: [],
				cities: [],
				streets: [],
				proSystems: [],
				fields: null,
				geodata: null,
				validation: false,
			};
		},
		computed: {
			...mapGetters({
				lightboxObjectEditVisible: "lightboxObjectEditVisible",
				lightboxObjectEditPayload: "lightboxObjectEditPayload",
				dealers: "getSystemsDealers",
			}),
			state() {
				return this.$store.state;
			},
		},
		methods: {
			...mapMutations(["hideLightboxObjectEdit"]),
			...mapActions(["newEditSystemsObject"]),

			/* INIT FUNCTIONS */
			initLightbox() {
				this.lightbox = {
					header: "Редактирование объекта",
				};

				this.initLightboxFalseBody();
				this.loadGEOData();
				this.loadRegions();
				this.loadProSystems();
			},
			initLightboxFalseBody() {
				this.lightbox.body = new Array(7).fill({
					kind: "single",
					type: "input",
					name: "name",
					title: "Заголовок",
					value: "Значение",
					status: "default",
					error: false,
					errorMessage: "Неверный формат",
				});
			},
			initLightboxBody() {
				let payload = this.lightboxObjectEditPayload;

				this.lightbox.body = [
					{
						kind: "single",
						type: "input",
						name: "name",
						title: "Название объекта",
						value: payload.params.name,
						status: "valid",
						error: false,
						errorMessage: "Неверный формат",
					},
					{
						kind: "single",
						type: "dropdown",
						name: "dealer",
						title: "Дилер",
						value: payload.params.dealer.name,
						dropdown: {
							type: "simple",
							name: payload.params.dealer.id,
							value: payload.params.dealer.name,
							status: "valid",
							error: false,
							errorMessage: "Неверный формат",
							categories: this.dealers,
						},
					},
					{
						kind: "single",
						type: "dropdown",
						name: "region",
						title: "Регион",
						value: "",
						dropdown: {
							type: "simple",
							name: "",
							value: this.geodata.region.name || "",
							status: this.geodata.region.name ? "valid" : "default",
							error: false,
							errorMessage: "Неверный формат",
							categories: this.regions,
						},
					},
					{
						kind: "single",
						type: "dropdown",
						name: "city",
						title: "Населенный пункт",
						value: "",
						disabled: this.geodata.city.name ? false : true,
						dropdown: {
							type: "simple",
							name: "",
							value: this.geodata.city.name || "",
							status: this.geodata.city.name ? "valid" : "default",
							error: false,
							errorMessage: "Неверный формат",
							categories: this.cities,
						},
					},
					{
						kind: "single",
						type: "dropdown",
						name: "street",
						title: "Улица",
						value: "",
						disabled: this.geodata.street === null || this.geodata.street?.name ? false : true,
						dropdown: {
							type: "simple",
							name: "",
							value: this.geodata.street === null ? "Отсутствует в списке" : this.geodata.street?.name || "",
							status: this.geodata.street === null || this.geodata.street?.name ? "valid" : "default",
							error: false,
							errorMessage: "Неверный формат",
							categories: this.streets,
						},
					},
					{
						kind: "double",
						first: {
							type: "input",
							name: "home",
							title: "Дом",
							value: this.geodata.home || "",
							status: this.geodata.home ? "valid" : "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						last: {
							type: "input",
							name: "apartment",
							title: "Квартира/помещение",
							value: this.geodata.apartment || null,
							status: this.geodata.apartment ? "valid" : "default",
							error: false,
							errorMessage: "Неверный формат",
						},
						status: "default",
					},
					{
						kind: "single",
						type: "input",
						name: "comment",
						title: "Комментарий",
						value: this.geodata.comment || "",
						status: this.geodata.comment ? "valid" : "default",
						error: false,
						errorMessage: "Неверный формат",
					},
				];

				this.fields = {
					id: this.geodata.id,
					system: payload.system,
					type: payload.params.type,
					name: payload.params.name,
					dealer: payload.params.dealer.id,
					region: this.geodata.region.id,
					city: this.geodata.city.id,
					street: this.geodata.street?.id || null,
					home: this.geodata.home,
					apartment: +this.geodata.apartment,
					pro_system_id: null,
					comment: this.geodata.comment,
				};

				this.loadCities();
				this.loadStreets();
				this.checkValidation();
			},
			loadGEOData() {
				this.loading = true;
				let payload = this.lightboxObjectEditPayload;

				axios
					.get(`${this.state.common.api2}/getSystem/${payload.system}`, this.state.common.headers)
					.then((response) => {
						if (response?.data) {
							this.geodata = response?.data.geo_data;

							this.initLightboxBody();
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			loadRegions() {
				this.loading = true;

				axios
					.get(`${this.state.common.api}/geo-regions`, this.state.common.headers)
					.then((response) => {
						this.regions = response.data.data.map((item) => {
							let obj = {
								id: item.id,
								name: "region",
								title: item.name,
							};
							return obj;
						});
					})
					.catch((error) => {
						console.log(error);
					});
			},
			loadCities() {
				let citiItem = this.lightbox.body.find((item) => item.name == "city");

				axios
					.get(
						`${this.state.common.api}/geo-cities?filters[from_region][$eq]=${this.geodata.region.id}`,
						this.state.common.headers
					)
					.then((response) => {
						this.cities = response.data.data.map((item) => {
							let obj = {
								id: item.id,
								name: "city",
								title: item.name,
							};
							return obj;
						});

						if (citiItem) {
							citiItem.disabled = false;
							citiItem.dropdown.categories = this.cities;
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			loadStreets() {
				let streetItem = this.lightbox.body.find((item) => item.name == "street");

				axios
					.get(
						`${this.state.common.api}/geo-streets?filters[from_city][$eq]=${this.geodata.city.id}`,
						this.state.common.headers
					)
					.then((response) => {
						this.loading = false;

						this.streets = response.data.data.map((item) => {
							let obj = {
								id: item.id,
								name: "street",
								title: item.name,
							};
							return obj;
						});

						if (streetItem) {
							streetItem.disabled = false;
							streetItem.dropdown.categories = this.streets;

							streetItem.dropdown.categories.push({
								id: "absent",
								name: "street",
								title: "Отсутствует в списке",
							});
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			loadProSystems() {
				axios
					.get(
						`${this.state.common.api}/systems/?filters[type][$eq]=pro&filters[isDemo][$eq]=false&pagination[limit]=-1&sort=id:desc`,
						this.state.common.headers
					)
					.then((response) => {
						this.proSystems = response.data.data.map((item) => {
							let obj = {
								id: item.id,
								name: "system",
								title: item.name,
							};
							return obj;
						});
					})
					.catch((error) => {
						console.log(error);
					});
			},

			/* SPECIAL HANDLERS */
			handleInputCommon(payload) {
				let input = this.lightbox.body.find((element) => element.name == payload.name);

				if (input) {
					input.value = payload.value;

					this.fields[input.name] = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						input.status = "valid";
						input.error = false;
					} else {
						input.status = "invalid";
						input.error = true;
					}
				}
			},
			handleInputDouble(payload) {
				let inputFirst = this.lightbox.body.find(
					(element) => element.kind == "double" && element.first.name == payload.name
				);
				let inputLast = this.lightbox.body.find(
					(element) => element.kind == "double" && element.last.name == payload.name
				);

				if (inputFirst) {
					inputFirst.first.value = payload.value;
					this.fields[inputFirst.first.name] = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						inputFirst.first.status = "valid";
						inputFirst.first.error = false;
					} else {
						inputFirst.first.status = "invalid";
						inputFirst.first.error = true;
					}
				} else if (inputLast) {
					inputLast.last.value = payload.value;
					this.fields[inputLast.last.name] = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						inputLast.last.status = "valid";
						inputLast.last.error = false;
					} else {
						inputLast.last.status = "invalid";
						inputLast.last.error = true;
					}
				}
			},

			handleDropdownCommon(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);

				if (dropdown) {
					dropdown.dropdown.name = payload.value;
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					if (dropdown.name == "street") {
						if (payload.id == "absent") this.fields[dropdown.name] = null;
						else this.fields[dropdown.name] = +payload.id;
					} else this.fields[dropdown.name] = +payload.id;
				}
			},
			handleDropdownRegions(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);
				let citiItem = this.lightbox.body.find((item) => item.name == "city");
				let streetItem = this.lightbox.body.find((item) => item.name == "street");

				if (citiItem) {
					citiItem.disabled = true;
					citiItem.dropdown.value = "";
					citiItem.dropdown.status = "default";
				}

				if (streetItem) {
					streetItem.disabled = true;
					streetItem.dropdown.value = "";
					streetItem.dropdown.status = "default";
				}

				if (dropdown) {
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					this.fields[dropdown.name] = payload.id;

					this.loading = true;

					axios
						.get(
							`${this.state.common.api}/geo-cities?filters[from_region][$eq]=${payload.id}`,
							this.state.common.headers
						)
						.then((response) => {
							this.loading = false;

							this.cities = response.data.data.map((item) => {
								let obj = {
									id: item.id,
									name: "city",
									title: item.name,
								};
								return obj;
							});

							if (citiItem) {
								citiItem.disabled = false;
								citiItem.dropdown.categories = this.cities;
							}
						})
						.catch((error) => {
							console.log(error);
						});
				}
			},
			handleDropdownCities(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);
				let streetItem = this.lightbox.body.find((item) => item.name == "street");

				if (streetItem) {
					streetItem.disabled = true;
					streetItem.dropdown.value = "";
					streetItem.dropdown.status = "default";
				}

				if (dropdown) {
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					this.fields[dropdown.name] = payload.id;

					this.loading = true;

					axios
						.get(
							`${this.state.common.api}/geo-streets?filters[from_city][$eq]=${payload.id}`,
							this.state.common.headers
						)
						.then((response) => {
							this.loading = false;

							this.streets = response.data.data.map((item) => {
								let obj = {
									id: item.id,
									name: "street",
									title: item.name,
								};
								return obj;
							});

							if (streetItem) {
								streetItem.disabled = false;
								streetItem.dropdown.categories = this.streets;

								streetItem.dropdown.categories.push({
									id: "absent",
									name: "street",
									title: "Отсутствует в списке",
								});
							}
						})
						.catch((error) => {
							console.log(error);
						});
				}
			},
			handleDropdownProSystem(payload) {
				let dropdown = this.lightbox.body.find((element) => element.name == payload.name);

				if (dropdown) {
					dropdown.dropdown.value = payload.title;
					dropdown.dropdown.status = "valid";

					this.fields[dropdown.name] = payload.id;
				}
			},
			checkValidation() {
				if (this.lightbox.body?.length) {
					this.validation = this.lightbox.body.every((element) => {
						if (element.kind == "single") {
							if (element.type == "input") return element.status == "valid";
							if (element.type == "dropdown") return element.dropdown.status == "valid";
						} else if (element.kind == "double") {
							if (element.first.type == "input") return element.first.status == "valid";
							if (element.last.type == "input") return element.last.status == "valid";
						}
					});
				}
			},

			/* EVENT HANDLERS */
			onChange(event, source) {
				let payload = null;

				if (source === "input") {
					payload = {
						name: event.target.name,
						value: event.target.value,
						event: event.type,
					};

					if (payload.name == "home" || payload.name == "apartment") this.handleInputDouble(payload);
					else this.handleInputCommon(payload);
				}

				if (source === "dropdown") {
					if (event.target.closest(".dropdown__item")) {
						payload = {
							name: event.target.closest(".dropdown").getAttribute("name"),
							id: event.target.closest(".dropdown__item").getAttribute("data-id"),
							title: event.target.closest(".dropdown__item").querySelector(".dropdown__title").innerHTML,
							value: event.target.closest(".dropdown__item").getAttribute("data-name"),
						};

						if (payload.name == "region") this.handleDropdownRegions(payload);
						else if (payload.name == "city") this.handleDropdownCities(payload);
						else if (payload.name == "pro_system_id") this.handleDropdownProSystem(payload);
						else this.handleDropdownCommon(payload);
					}
				}

				this.checkValidation();
			},
			onCancel() {
				this.hideLightboxObjectEdit();
				this.onReset();
			},
			onApply() {
				this.newEditSystemsObject(this.fields);
				this.hideLightboxObjectEdit();
				this.onReset();
			},
			onReset() {
				if (this.lightbox.body?.length) {
					this.lightbox.body.forEach((element) => {
						element.value = null;
						element.status = "default";
						element.error = false;
					});
				}

				this.type = null;
				this.fields = null;
				this.geodata = null;
				this.validation = false;
			},
		},
		watch: {
			lightboxObjectEditVisible: function (newVal) {
				if (newVal) this.initLightbox();
			},
		},
	};
</script>

<style lang="scss" scoped></style>
